/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MaintenanceScheduleStateEnum } from './maintenanceScheduleStateEnum';


export interface MaintenanceScheduleOperatorGetResponseSpec { 
    state: MaintenanceScheduleStateEnum;
    /**
     * Maintenance schedule start time
     */
    start_datetime?: Date;
    /**
     * Maintenance schedule end time
     */
    end_datetime?: Date;
    /**
     * List of maintenance email notification message ids if any
     */
    notification_ids?: Array<string>;
    /**
     * List of maintenance notification message group ids if any
     */
    message_group_ids?: Array<string>;
    /**
     * Maintenance schedule task id if exists
     */
    task_id?: string;
    /**
     * Operator who updated maintenance schedule info
     */
    updated_by?: string;
    /**
     * Maintenance schedule info update time
     */
    updated_timestamp: Date;
}
export namespace MaintenanceScheduleOperatorGetResponseSpec {
}


